module.exports = __webpack_public_path__ + "img/arrows.00935745.png";